module.exports = __webpack_public_path__ + "img/zhi1.cf827ab9.jpg";